import React from 'react';
import { Link } from "react-router-dom";

function Areas() {
  return (
    <section className="section-3">
        <div className="container">
            <div className="row m-0">
                <div className="col-lg-5 col-md-12 p-0" data-aos="fade-right" data-aos-delay="300">
                    <h2>Principais áreas</h2>
                    <ul>
                        <li><Link to="/Pesq"><i className="fa fa-angle-right" aria-hidden="true"></i>Sistemas de Apoio à Saúde</Link></li>
                        <li><Link to="/Pesq"><i className="fa fa-angle-right" aria-hidden="true"></i>Ciência de Dados</Link></li>
                        <li><Link to="/Pesq"><i className="fa fa-angle-right" aria-hidden="true"></i>Processamento Digital de Imagens</Link></li>
                        <li><Link to="/Pesq"><i className="fa fa-angle-right" aria-hidden="true"></i>Processamento de Linguagem Natural</Link></li>
                        <li><Link to="/Pesq"><i className="fa fa-angle-right" aria-hidden="true"></i>Interpretação de Dados</Link></li>
                        <li><Link to="/Pesq"><i className="fa fa-angle-right" aria-hidden="true"></i>Mineração de Dados Educacionais</Link></li>

                    </ul>
                </div>
                <div className="col-lg-7 col-md-12 p-0" data-aos="fade-left" data-aos-delay="300">
                    <figure>
                        <img className="inner-img" src="images/services-bg2.jpg" alt="services" />
                        <img className="out-sideimg" src="images/services-bg.jpg" alt="services" />
                    </figure>
                </div>
            </div>
        </div>
    </section>

    
    
  );
}

export default Areas;
;